import { BsX } from 'react-icons/bs'
import './index.css'

const ActiveFilterChips = props => {
  const {
    searchInput,
    activeCategoryId,
    activeRatingId,
    categoryOptions,
    changeSearchInput,
    changeCategory,
    changeRating,
    enterSearchInput
  } = props

  const hasFilters = searchInput || activeCategoryId || activeRatingId
  if (!hasFilters) return null

  const activeCat = categoryOptions.find(c => c.categoryId === activeCategoryId)

  return (
    <div className="active-filters-container">
      <span className="active-filters-label">Active Filters:</span>
      
      {searchInput && (
        <div className="filter-chip">
          Search: "{searchInput}"
          <button
            type="button"
            className="chip-remove"
            onClick={() => { changeSearchInput(''); setTimeout(enterSearchInput, 0); }}
          >
            <BsX />
          </button>
        </div>
      )}

      {activeCat && (
        <div className="filter-chip">
          Category: {activeCat.name}
          <button
            type="button"
            className="chip-remove"
            onClick={() => changeCategory('')}
          >
            <BsX />
          </button>
        </div>
      )}

      {activeRatingId && (
        <div className="filter-chip">
          Rating: {activeRatingId}+ Stars
          <button
            type="button"
            className="chip-remove"
            onClick={() => changeRating('')}
          >
            <BsX />
          </button>
        </div>
      )}
    </div>
  )
}

export default ActiveFilterChips
